import React from 'react';
import { SdfCarousel, SdfCarouselItem } from '@waypoint/react-components';

export interface IMDFCarouselProps {
  // A CSS class name for Carousel container.
  carouselClassName?: string;
  // The items to display in the Carousel.
  children: React.ReactNode;
  // A CSS class name for overriding styles.
  className?: string;
  // How many slides to scroll at once
  slidesToScroll?: number;
  // How many slides to show in one frame
  slidesToShow?: number
}

export const MDFCarousel = (props: IMDFCarouselProps) => {
  const { children, className, carouselClassName, slidesToScroll, slidesToShow, ...settings } = props;

  return (
    <SdfCarousel inset itemsPerPage={slidesToShow} {...settings}>
      {React.Children.map(children, (child, i) => (<SdfCarouselItem key={i} className={className}>{child}</SdfCarouselItem>))}
    </SdfCarousel>
  );
};

MDFCarousel.displayName = 'MDFCarousel';
